import React from 'react';
import PropTypes from 'prop-types';

import { palletsByCountry } from 'utils/journey';
import { DetailCell } from './styled';

const t = {
  american: 'Us',
  european: 'Eu',
};

const VehicleMaxPallets = ({ max_pallets, country, className, ...props }) => {
  const pallet_type = (country && palletsByCountry[country]) || palletsByCountry.default;
  const content = max_pallets ? `${max_pallets} ${t[pallet_type]}` : null;

  return (
    <DetailCell className={className} {...props}>
      {content}
    </DetailCell>
  );
};

VehicleMaxPallets.propTypes = {
  max_pallets: PropTypes.string,
  country: PropTypes.string,
  className: PropTypes.string,
};

export default VehicleMaxPallets;
